module.exports = {"620982100":"七里镇","620982101":"沙州镇","620982102":"肃州镇","620982103":"莫高镇","620982104":"转渠口镇","620982105":"阳关镇","620982106":"月牙泉镇","620982107":"郭家堡镇","620982108":"黄渠镇","620982401":"青海石油管理局生活基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620982.json
// module id = 3077
// module chunks = 0